import { ValueObject } from '../../../shared/models/ValueObject';

/**
 * 사용자 ID 값 객체
 */
export class UserId extends ValueObject<string> {
  private readonly _value: string;

  constructor(value: string) {
    super();
    this.validate(value);
    this._value = value;
  }

  get value(): string {
    return this._value;
  }

  private validate(value: string): void {
    if (!value) {
      throw new Error('UserId는 비어있을 수 없습니다');
    }
    if (value.length < 3) {
      throw new Error('UserId는 3자 이상이어야 합니다');
    }
  }

  protected equalsCore(vo: UserId): boolean {
    return this._value === vo._value;
  }

  protected copy(): UserId {
    return new UserId(this._value);
  }

  toString(): string {
    return this._value;
  }

  /**
   * 새로운 UserId 생성
   */
  static create(): UserId {
    // 실제로는 UUID나 다른 고유 ID 생성 로직 사용
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 9);
    return new UserId(`user_${timestamp}_${random}`);
  }

  /**
   * 기존 값으로부터 UserId 생성
   */
  static fromString(value: string): UserId {
    return new UserId(value);
  }
}